<template>
  <div v-loading="isLoading" class="py-2 mt-4">
    <div>
      <label
        class="required fs-15"
      >{{ $t(this.type===HODO_CREDIT_TYPE.accumulate?'Tỷ lệ Tích điểm Mua hàng':'Tỷ lệ chuyển đổi') }}</label>
      <div class="flex flex-col md:flex-row gap-4 md:items-center">
        <el-input
          :placeholder="$t('Nhập số tiền chuyển đổi')"
          class="cs-input"
          v-model="form.moneyValue"
          @input="handleChangeMoneyValue"
        >
          <template slot="append">VND</template>
        </el-input>
        <svg
          width="64"
          height="64"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.7073 16.7076L25.7073 20.7076C25.5197 20.8952 25.2652 21.0006 24.9998 21.0006C24.7344 21.0006 24.4799 20.8952 24.2923 20.7076C24.1047 20.5199 23.9993 20.2654 23.9993 20.0001C23.9993 19.7347 24.1047 19.4802 24.2923 19.2926L26.5861 17.0001H5.41356L7.70731 19.2926C7.89495 19.4802 8.00037 19.7347 8.00037 20.0001C8.00037 20.2654 7.89495 20.5199 7.70731 20.7076C7.51967 20.8952 7.26517 21.0006 6.99981 21.0006C6.73445 21.0006 6.47995 20.8952 6.29231 20.7076L2.29231 16.7076C2.19933 16.6147 2.12557 16.5044 2.07525 16.383C2.02493 16.2616 1.99902 16.1315 1.99902 16.0001C1.99902 15.8687 2.02493 15.7385 2.07525 15.6171C2.12557 15.4957 2.19933 15.3854 2.29231 15.2926L6.29231 11.2926C6.47995 11.1049 6.73445 10.9995 6.99981 10.9995C7.26517 10.9995 7.51967 11.1049 7.70731 11.2926C7.89495 11.4802 8.00037 11.7347 8.00037 12.0001C8.00037 12.2654 7.89495 12.5199 7.70731 12.7076L5.41356 15.0001H26.5861L24.2923 12.7076C24.1047 12.5199 23.9993 12.2654 23.9993 12.0001C23.9993 11.7347 24.1047 11.4802 24.2923 11.2926C24.4799 11.1049 24.7344 10.9995 24.9998 10.9995C25.2652 10.9995 25.5197 11.1049 25.7073 11.2926L29.7073 15.2926C29.8003 15.3854 29.874 15.4957 29.9244 15.6171C29.9747 15.7385 30.0006 15.8687 30.0006 16.0001C30.0006 16.1315 29.9747 16.2616 29.9244 16.383C29.874 16.5044 29.8003 16.6147 29.7073 16.7076Z"
            fill="#0C0C0D"
          />
        </svg>

        <el-input
          placeholder="Nhập số điểm chuyển đổi"
          class="cs-input"
          v-model="form.pointsValue"
          @input="handleChangePointValue"
        >
          <template slot="append">{{ $t('Điểm') }}</template>
        </el-input>
      </div>
      <div
        class="mt-1"
        v-if="configData.change_by_user && configData.change_by_user.name && formatTimeUpdate"
      >
        <span>{{ $t('Cập nhật lần cuối: ') }}</span>
        <strong>{{ formatTimeUpdate }}</strong>
        bởi
        <strong>{{ configData.change_by_user.name }}</strong>
      </div>
      <!-- <div>
        <label class="required fs-15">{{ $t('Sản phẩm áp dụng') }}</label>
        <div class="flex flex-col gap-3 mt-3">
          <el-radio
            v-model="form.applyType"
            :label="APPLY_PRODUCT_OPTIONS.allProduct"
          >{{ $t('Áp dụng cho tất cả sản phẩm') }}</el-radio>
          <el-radio
            v-model="form.applyType"
            :label="APPLY_PRODUCT_OPTIONS.prefixProduct"
          >{{ $t('Áp dụng cho sản phẩm cụ thể') }}</el-radio>
        </div>
      </div>
      <SelectedProducts
        :selectedProducts="selectedProducts"
        :applyType="form.applyType"
        @onSelectedAll="(type)=>form.applyType=type"
        @onChangeSelectedProducts="data=>selectedProducts=data"
      />-->
      <div class="flex justify-end items-center gap-2 mt-2">
        <!-- <el-button @click="isOpenModal = false">{{ $t('Huỷ') }}</el-button> -->
        <el-button
          type="primary"
          @click="handleSubmitAccumulate"
          :disabled="isLoading"
          class="text-white"
        >{{ $t('Lưu') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../../utils/appUtils'
import { HODO_CREDIT_TYPE } from '../../../utils/constants'
import SelectedProducts from './SelectedProducts.vue'

export const APPLY_PRODUCT_OPTIONS = {
  allProduct: 1,
  prefixProduct: 2
}

export default {
  name: 'HodoCreditLayout',
  components: { SelectedProducts },
  props: {
    type: Number
  },
  data () {
    return {
      form: {
        moneyValue: null,
        pointsValue: null,
        applyType: APPLY_PRODUCT_OPTIONS.allProduct
      },
      APPLY_PRODUCT_OPTIONS,
      HODO_CREDIT_TYPE,
      isLoading: false,
      selectedProducts: [],
      realData: {
        moneyValue: null,
        pointsValue: null
      },
      configData: {}
    }
  },
  watch: {
    'form.applyType' () {
      if (this.form.applyType === APPLY_PRODUCT_OPTIONS.allProduct) {
        this.selectedProducts = []
      }
    }
  },
  computed: {
    formatTimeUpdate () {
      if (!this.configData?.updated_at) return
      return window
        .moment(this.configData.updated_at)
        .format('HH:mm DD/MM/YYYY')
    }
  },
  created () {
    this.getExchangeRateByOrgId()
  },
  methods: {
    async handleSubmitAccumulate () {
      if (!this.$globalOrg?.id) return

      if (!this.realData.moneyValue || !this.realData.pointsValue) {
        this.$message({
          message: this.$t('Vui lòng điển đầy đủ thông tin bắt buộc'),
          type: 'warning'
        })
        return
      }

      // if (
      //   this.form.applyType === APPLY_PRODUCT_OPTIONS.prefixProduct &&
      //   !this.selectedProducts?.length
      // ) {
      //   this.$message({
      //     message: this.$t('Vui lòng chọn sản phẩm áp dụng'),
      //     type: 'warning'
      //   })
      //   return
      // }
      let label =
        this.form.applyType === APPLY_PRODUCT_OPTIONS.allProduct
          ? 'Bạn có chắc chắn muốn áp dụng tích điểm cho tất cả sản phẩm không?'
          : 'Bạn có chắc chắn muốn áp dụng cho các sản phẩm đã chọn không?'

      if (this.type === HODO_CREDIT_TYPE.deposit) {
        label = 'Bạn có chắc chắn muốn áp dụng tỷ lệ này không?'
      }
      const title =
        this.type === HODO_CREDIT_TYPE.accumulate
          ? 'Tích điểm'
          : 'Thiết lập tỷ lệ'

      this.$confirm(label, title, {
        dangerouslyUseHTMLString: true,
        cancelButtonText: this.$t('lbl_cancel'),
        confirmButtonText: this.$t('lbl_confirm')
      })
        .then(async () => {
          try {
            this.isLoading = true

            const params = {
              apply_range:
                this.form.applyType === APPLY_PRODUCT_OPTIONS.allProduct
                  ? 'All'
                  : '',
              bill_value: Number(this.realData.moneyValue),
              equivalent_point: Number(this.realData.pointsValue),
              org_id: this.$globalOrg?.id,
              type: this.type
            }

            if (this.form.applyType === APPLY_PRODUCT_OPTIONS.prefixProduct) {
              delete params.apply_range
              params.product_ids = this.selectedProducts?.map(item => item?.id)
            }
            if (this.type === HODO_CREDIT_TYPE.deposit) {
              delete params.apply_range
            }

            const response = await this.$rf
              .getRequest('DoctorRequest')
              .submitAccumulatePoints(params)

            if (response.status === 200) {
              this.$message({
                message: this.$t(`Áp dụng ${title?.toLowerCase()} thành công`),
                type: 'success'
              })
              this.getExchangeRateByOrgId()

              // this.selectedProducts = []
              // this.form = {
              //   moneyValue: null,
              //   pointsValue: null,
              //   applyType: APPLY_PRODUCT_OPTIONS.allProduct
              // }
            }
          } catch (error) {
            console.log(error)
            this.$message({
              message: this.$t(`Áp dụng ${title?.toLowerCase()} thất bại`),
              type: 'error'
            })
          } finally {
            this.isLoading = false
          }
        })
        .catch(() => {})
    },
    handleChangePointValue (value) {
      const newValue = Number(value?.toString()?.replaceAll(',', ''))
      this.form.pointsValue = appUtils.numberFormat(newValue)
      this.realData.pointsValue = newValue
    },
    handleChangeMoneyValue (value) {
      const newValue = Number(value?.toString()?.replaceAll(',', ''))
      this.form.moneyValue = appUtils.numberFormat(newValue)

      this.realData.moneyValue = newValue
    },
    async getExchangeRateByOrgId () {
      if (!this.$globalOrg?.id || !this.type) return

      try {
        const params = {
          type: this.type
        }

        const response = await this.$rf
          .getRequest('DoctorRequest')
          .getExchangeRateByOrgId(this.$globalOrg.id, params)

        this.configData = response?.data?.[0] || {}
        this.form.pointsValue = this.roundToFourDecimals(
          this.configData?.equivalent_point
        )
        this.form.moneyValue = this.roundToFourDecimals(
          this.configData?.bill_value
        )
        this.realData = {
          pointsValue: this.configData?.equivalent_point || '',
          moneyValue: this.configData?.bill_value || ''
        }
      } catch (error) {
        console.log(error)
      }
    },
    roundToFourDecimals (number) {
      if (!number) return ''
      const isInteger = Number.isInteger(number)

      let result
      if (isInteger) {
        result = appUtils.numberFormat(number)
      } else {
        const formatNumber = parseFloat(number).toFixed(4)
        const splitNumber = formatNumber.split('.')
        const intNumber = appUtils.numberFormat(splitNumber[0])
        result = `${intNumber}.${splitNumber[1]}`
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .cs-input {
    .el-input__inner {
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      border: 1px solid #dcdfe6 !important;
      background-color: white !important;
      text-align: right;
    }

    .el-input-group__append {
      background-color: white !important;
    }
  }
}
</style>